import { Form } from '../core'

$.fn.NewsletterForm = function() {
  let self = this
  self.section = self.closest('.newsletter')
  self.form = undefined

  self.initialize_form = function() {
    self.form = new Form(self.get(0), {
      ajax_redirect: false,
      auto_scroll: false,
      floating_labels: self.hasClass('newsletter-form--simple'),
      onSubmit: function() {
        $('.form-success').slideUp(function() {
          $(this).remove();
        })
      },
      onSuccess: function() {
        let isPopup = self.closest('.featured-message').length
        self.form.getForm().enable_fields()
        self.find('input[name="email_address"]').val('').trigger('blur')
        self.find('input[name="email_address"]').closest('.field').removeClass('field--populated field--focused')
        let $success = $('<p class="form-success form-success--newsletter">')
        $success.html(saintlo_l10n.NEWSLETTER_SUCCESS).hide()
        if (self.hasClass('newsletter-form--simple')) {
          if (isPopup) {
            let $container = self.closest('.featured-message__container')
            $container.css({
              height: $container.outerHeight(false) + 'px',
            })
            self.parent().find('p').fadeOut(250)
            self.fadeOut(250, function() {
              self.before($success.fadeIn(250))
            })
          } else {
            self.before($success.fadeIn(250))
          }
        } else if (self.hasClass('newsletter-form--full')) {
          if (!isPopup) {
            self.targetTop = self.closest('.row').offset().top - $('.header').outerHeight(false) - ($.mlmi.mobile.isMobile ? 32 : 80)
          }
          self.after($success)
          if (self.parents('#cta-newsletter').length) {
            self.parents('#cta-newsletter').find('.text-content p').fadeOut(250)
          }
          self.fadeOut(250, function() {
            if (!isPopup) {
              $('html, body').scrollTo(self.targetTop, 400, 5, 'easeInOutQuart')
            }
            $success.fadeIn(250, function() {
              setTimeout(function() {
                if (isPopup) {
                  self.closest('.featured-message').attr('aria-hidden', 'true')
                }
              }, 3000);
            })
          })
        }
      },
      onError: function() {
        requestAnimationFrame(function() {
          self.removeClass('newsletter-form--blocked')
          self.find('.form-error--invisible').removeClass('form-error--invisible')
          self.find('.field-error--invisible').removeClass('field-error--invisible')
        })
      },
    })
  }

  return function() {
    self.initialize_form()
    return self
  }()
}
